import { createAlgoliaClient } from "../common/utils/algoliaFactory";
import { resolveMeta } from "./utils/headings";
export { default } from "./App";
export var Utils = {
  resolveMeta: resolveMeta,
  createAlgoliaClient: createAlgoliaClient
};
export { cloudFortifiedFilter } from "./config/discoverCollections";
import * as _TelemetryTasks from "./telemetry/tasks";
export { _TelemetryTasks as TelemetryTasks };